import { render, staticRenderFns } from "./vipGrade.vue?vue&type=template&id=db94b122&scoped=true&"
import script from "./vipGrade.vue?vue&type=script&lang=js&"
export * from "./vipGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db94b122",
  null
  
)

export default component.exports